import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=0723ed92&scoped=true&"
import script from "./FormSection.vue?vue&type=script&lang=ts&"
export * from "./FormSection.vue?vue&type=script&lang=ts&"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=0723ed92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723ed92",
  null
  
)

export default component.exports